import roles from "../../../constants/roles";
import { Link } from "react-router-dom";
import { softScheduleStrings } from "../../../components/StringBundle";
import { filterTableSorter } from "../../../components/TableCustomSort";
import { formatDateSafe } from "../../common";
import { commonStrings } from "../../../components/StringBundle";
const softScheduleGridColumns = softScheduleStrings.grid;
const softScheduleStatusString = softScheduleStrings.forms;
const factoryCodesStrings = commonStrings.factoryCode;

export function getColumns(currentUserRole) {
  return [
    { id: "record_id", label: softScheduleStatusString.recordNo },
    { id: "order_dispatch_number", label: softScheduleStatusString.softScheduleLine },
    { id: "scheduling_date", label: softScheduleStatusString.softScheduleDate },
    { id: "capacity_per_day", label: softScheduleStatusString.productionCapacity },
    { id: "capacity_occupied", label: softScheduleStatusString.capacityProd },
    { id: "order_quantity_left", label: softScheduleStatusString.orderQtyLeft },
    { id: "capacity_left", label: softScheduleStatusString.capacityLeft },
    {
      id: "capacity_left_percentage",
      label: softScheduleStatusString.capacityLeftPercentage,
    },
    { id: "status", label: softScheduleStatusString.status }
  ];
}

function canViewLink(currentUserRole, roles){
  return ![roles.managerPurchaseGC, roles.purchaseExecutiveGC].includes(currentUserRole);
}

function canHideSampleLinks(currentUserRole, roles){
  return [
    roles.commercialAssociative,
     roles.managerCommerical, 
     roles.commercialExecutive,
     roles.commercialHod
    ].includes(currentUserRole);
}

const softScheduleColumnTypes = {
  schedule_start_date: "date",
  schedule_end_date: "date",
};

export const status_list = [
  { 
    value: "SS-ST-1", 
    label: softScheduleStatusString.this_month, 
    key: "this_month",
    messageEmpty: softScheduleStatusString.noSchedulesThisMonth
  },
  { 
    value: "SS-ST-2", 
    label: softScheduleStatusString.this_week, 
    key: "this_week",
    messageEmpty: softScheduleStatusString.noSchedulesThisWeek
  },
  { 
    value: "SS-ST-3", 
    label: softScheduleStatusString.today, 
    key: "today",
    messageEmpty: softScheduleStatusString.noSchedulesToday
  },
  { 
    value: "SS-ST-4", 
    label: softScheduleStatusString.next_month, 
    key: "next_month",
    messageEmpty: softScheduleStatusString.noSchedulesNextMonth
  },
  { 
    value: "SS-ST-5", 
    label: softScheduleStatusString.all, 
    key: "all",
    messageEmpty: softScheduleStatusString.noRecordsFound
  },
]

export const GetSoftScheduleGridColumns = (currentUserRole) => {
  const result = [];
  for (const id in softScheduleGridColumns) {
    const label = softScheduleGridColumns[id];
    const colType = softScheduleColumnTypes[id] || "text";
    let colDef;
      if (id === "record_id") {
        colDef = {
          title: label,
          dataIndex: id,
          key: id,
          type: colType,
          render: (text, record) => (
            <span>
              <Link  to={`/soft-scheduling/${encodeURIComponent(record.order_dispatch_number)}/view?tab=soft-schedule`}>{text}</Link>
            </span>
          ),
        };
      } else if (id === "order_number") {
        colDef = {
          title: label,
          dataIndex: id,
          key: id,
          type: colType,
          render: (text, record) => {
            const isHyperLink = canViewLink(currentUserRole, roles);
            return isHyperLink ? (
              <Link  to={`/order/${encodeURIComponent(record.order_id)}/view?tab=order`}>{text}</Link>
            ) : text;
          },
        };
      } else if (id === "order_dispatch_number") {
        colDef = {
          title: label,
          dataIndex: id,
          key: id,
          type: colType,
          render: (text, record) => {
            const isHyperLink = canViewLink(currentUserRole, roles);
            return isHyperLink ? (
              <Link  to={`/orderdispatch/${encodeURIComponent(record.order_dispatch_id)}/view?tab=orderdispatch` }>{text}</Link>
            ) : text;
          },
        };
      } else if (id === "alternative_sample") {
        colDef = {
          title: label,
          dataIndex: id,
          key: id,
          type: colType,
          render: (text, record) => {
            const notAllowToNavigate = canHideSampleLinks(currentUserRole, roles)
            return(
              notAllowToNavigate ? text : <Link  to={`/alternative-sample/${encodeURIComponent(record.alternative_sample_id)}/view?tab=details` }>{text}</Link>
            )
          },
        };
      } else if (id === "customer_sample_code") {
        colDef = {
          title: label,
          dataIndex: id,
          key: id,
          type: colType,
          render: (text, record) => {
            const notAllowToNavigate = canHideSampleLinks(currentUserRole, roles)
            return(
              notAllowToNavigate ? text : <Link  to={`/customer-sample/${record?.customer_sample_id}/view?tab=details`}>{text}</Link>
            )
          },
        };
      } else if (colType === "date") {
        colDef = {
          title: label,
          dataIndex: id,
          key: id,
          type: colType,
          sorter: filterTableSorter(id, 'date', 'YYYY-MM-DD'),
          render: formatDateSafe
        };
      } else {
        colDef = {
          title: label,
          dataIndex: id,
          key: id,
          type: colType,
          width: "10%",
        };
      }
      if (colDef) result.push(colDef);
    }
    return result;
};

export const factoryCodesArr = [
  { label: factoryCodesStrings.fnb, value: "F&B" },
  { label: factoryCodesStrings.duggirala, value: "Duggirala" },
  { label: factoryCodesStrings.sez, value: "SEZ" },
  { label: factoryCodesStrings.vietnam, value: "Vietnam" },
  { label: factoryCodesStrings.switzerland, value: "Switzerland" },
]